import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'nav',
    component: () => import(/* webpackChunkName: "nav" */ '@/nav/navLeft.vue'),
    redirect: '/user',
    meta: { title: '天联SD-WAN官网|个人中心' },
    children: [
    {
      path: '/user',
      name: 'user',
      component: () => import(/* webpackChunkName: "user" */ '@/views/user/userInfo.vue'),
    }
    ,{
      path: '/selectCity',
      name: 'selectCity',
      component: () => import(/* webpackChunkName: "selectCity" */ '@/views/user/selectCity.vue'),
    },{
      path: '/orderEndDetails',
      name: 'orderEndDetails',
      component: () => import(/* webpackChunkName: "orderEndDetails" */ '@/views/order/orderEndDetails.vue'),
    }
    ,{
      path: '/orderIngDetails',
      name: 'orderIngDetails',
      component: () => import(/* webpackChunkName: "orderIngDetails" */ '@/views/order/orderIngDetails.vue'),
    }
    ,{
      path: '/orderNoDetails',
      name: 'orderNoDetails',
      component: () => import(/* webpackChunkName: "orderNoDetails" */ '@/views/order/orderNoDetails.vue'),
    }
    ,{
      path: '/group',
      name: 'group',
      component: () => import(/* webpackChunkName: "group" */ '@/views/group/groupIndex.vue'),
    }
    ,{
      path: '/accountRecharge',
      name: 'accountRecharge',
      component: () => import(/* webpackChunkName: "accountRecharge" */ '@/views/recharge/accountRecharge.vue'),
    }
    ,{
      path: '/bankTransfer',
      name: 'bankTransfer',
      component: () => import(/* webpackChunkName: "bankTransfer" */ '@/views/recharge/bankTransfer.vue'),
    }
    ,{
      path: '/payLog',
      name: 'payLog',
      component: () => import(/* webpackChunkName: "payLog" */ '@/views/paylog/payLog.vue'),
    }
    ,{
      path: '/order',
      name: 'order',
      component: () => import(/* webpackChunkName: "order" */ '@/views/order/orderManagement.vue'), 
      redirect: '/orderNo',
      children: [{
        path: '/orderNo',
        name: 'orderNo',
        component: () => import(/* webpackChunkName: "orderNo" */ '@/views/order/orderNo.vue'),
      },
      {
        path: '/orderIng',
        name: 'orderIng',
        component: () => import(/* webpackChunkName: "orderIng" */ '@/views/order/orderIng.vue'),
      },
      {
        path: '/orderEng',
        name: 'orderEng',
        component: () => import(/* webpackChunkName: "orderEng" */ '@/views/order/orderEng.vue'),
      }
      ]
    }
    ],
    
  },
  {
    path:'/',
    name:'buyNav',
    component: () => import(/* webpackChunkName: "buyNav" */ '@/nav/buyNav.vue'),
    meta: { title: '天联SD-WAN官网|个人中心' },
    children:[
      {
        path: '/buy',
        name: 'buy',
        component: () => import(/* webpackChunkName: "buy" */ '@/views/buy/buyLayout.vue'),
      },
      {
        path: '/buyContent',
        name: 'buyContent',
        component: () => import(/* webpackChunkName: "buyContent" */ '@/views/buy/buyContent.vue'),
      },
      {
        path: '/buyUpgrade',
        name: 'buyUpgrade',
        component: () => import(/* webpackChunkName: "buyUpgrade" */ '@/views/buy/buyUpgrade.vue'),
      },
      {
        path: '/buyRenew',
        name: 'buyRenew',
        component: () => import(/* webpackChunkName: "buyRenew" */ '@/views/buy/buyRenew.vue'),
      },
      {
        path: '/buyAdd',
        name: 'buyAdd',
        component: () => import(/* webpackChunkName: "buyAdd" */ '@/views/buy/buyAdd.vue'),
      },{
        path: '/buyBox',
        name: 'buyBox',
        component: () => import(/* webpackChunkName: "buyBox" */ '@/views/buy/buyBox.vue'),
      },{
        path: '/buyBoxContent',
        name: 'buyBoxContent',
        component: () => import(/* webpackChunkName: "buyBoxContent" */ '@/views/buy/buyBoxContent.vue'),
      }
    ]
  },{
    path:'/helpCenter',
    name:'helpCenter',
    component: () => import(/* webpackChunkName: "helpCenter" */ '@/views/help/helpCenter.vue'),
    redirect: '/helpList',
    meta: { title: '天联SD-WAN官网|帮助中心' },
    children:[
      {
        path: '/helpList',
        name: 'helpList',
        component: () => import(/* webpackChunkName: "helpList" */ '@/views/help/helpList.vue'),
      },
      {
        path: '/helpDetails',
        name: 'helpDetails',
        component: () => import(/* webpackChunkName: "helpDetails" */ '@/views/help/helpDetails.vue'),
      },
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  // history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title
  next()
})


export default router
